import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import renderSelectField from 'src/shared/components/form/Select';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';

const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-group">
        <div className="form__form-group">
            <input
                {...input}
                  className="custom-placeholder"
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

const HubAddOrUpdate = ({ handleSubmit,faqData }) => {
    return (
        <Card>
            <CardBody>
                <Col lg={12} md={12}>
                    <form className="form-animated" onSubmit={handleSubmit}>
                        <Row style={{ width: "100%" }}>
                            <Col lg={6} md={6}>
                                <div className="form__form-group">
                                    <span className="required_field">* </span>{" "}    <span className="form__form-group-label">FAQ Type</span>
                                    <div className="form__form-group-field">
                                        <Field
                                            validate={[required]}
                                            name="type"
                                            component={renderSelectField}
                                            type="text"
                                            label="state"
                                            placeholder="Select Type"
                                            options={[
                                                { value: 1, label: "Mobile" },
                                                { value: 2, label: "Web" },

                                            ]}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} md={6}>
                                <div className="form__form-group">
                                    <span className="required_field">* </span>{" "}   <span className="form__form-group-label">FAQ Keyword </span>
                                    <div className="form__form-group-field">
                                        <Field
                                            validate={[required]}
                                            name="keyword"
                                            component={renderField}
                                            type="text"
                                            label="state"
                                            placeholder="Enter Keyword"

                                        />
                                    </div>
                                </div>
                            </Col>
                            {/* <Col lg={6} md={6}>
                    <div className="form__form-group">
                      <span className="form__form-group-label">FAQ Type</span>
                      <div className="form__form-group-field">
                        <Field
                          validate={[required]}
                          name="stateInfo"
                          component={renderSelectField}
                          type="text"
                          label="state"
                          placeholder="Select State"
                          options={[
                            { value: 1, label: "Mobile" },
                            { value: 2, label: "Web" },
    
                          ]}
                        />
                      </div>
                    </div>
                  </Col> */}
                        </Row>
                        <Row style={{ width: "100%" }}>
                            <Col lg={12} md={12}>
                                <div className="form__form-animated-group">
                                    <div className="form__form-group">
                                        <span className="required_field">* </span>{" "}
                                        <span className="form__form-animated-group-label">Rider Specific Question?</span>
                                        <div className="form__form-animated-group-field">
                                            <Field
                                                name="isRiderSpecificInformation"
                                                component={renderToggleButtonField}
                                                defaultChecked={faqData?.isRiderSpecificInformation}/>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className="form__form-group">
                            <span className="required_field">* </span>{" "}<span className="form__form-group-label">Question</span>
                            <div className="form__form-group-field">
                                <Field validate={required} style={{ height: "100px" }}
                                    component={'textarea'} name="question" type="textarea" placeholder="question" />
                            </div>
                        </div>
                        <div className="form__form-group">
                            <span className="required_field">* </span>{" "}<span className="form__form-group-label">Answer</span>
                            <div className="form__form-group-field">
                                <Field validate={required} style={{ height: "200px" }}
                                    component={'textarea'} name="answer" type="textarea" placeholder="Answer" />
                            </div>
                        </div>


                        <div className="form__OnboardingButton">
                            <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                                <Button color="primary" type="submit" className="account__btn">Submit</Button>
                            </ButtonToolbar>
                        </div>
                    </form>
                </Col>
            </CardBody>
        </Card>
    );
};


HubAddOrUpdate.propTypes = {
    HubAddOrUpdate: PropTypes.func.isRequired,
};


const mapStateToProps = (state, data) => {
    if (data && data.faqData) {
        return {
            initialValues: {

                faqId: data.faqData.faqId,
                question: data.faqData.question,
                answer: data.faqData.answer,
                keyword: data.faqData.keyword,
                isRiderSpecificInformation:data.faqData.isRiderSpecificInformation,
                type: { "value": data?.faqData.type, "label": data?.faqData.type == 1 ? "Mobile" : "Web" },
            }
        }

    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'HubAddOrUpdateForm', enableReinitialize: true })(HubAddOrUpdate))